module.exports = __webpack_public_path__ + "img/Sphygmomanometer.3bbe5b9b.png";